import { render, staticRenderFns } from "./DashChart.vue?vue&type=template&id=f0e195c6&scoped=true&"
import script from "./DashChart.vue?vue&type=script&lang=js&"
export * from "./DashChart.vue?vue&type=script&lang=js&"
import style0 from "./DashChart.vue?vue&type=style&index=0&id=f0e195c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e195c6",
  null
  
)

export default component.exports